import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { useHoverDirty } from 'react-use';
import classNames from 'classnames';
import type { LibUploadingMap } from '@types';
import Button from '@components/Button';
import Icon from '@components/Icon';
import ImgUpload from './img-upload.png';
import ImgUploading from './img-uploading.svg';

interface Props {
  className?: string;
  itemMap: LibUploadingMap;
  onClick: () => void;
}

function UploadButton({ onClick, itemMap, className }: Props) {
  const rootRef = React.useRef<HTMLDivElement>(null);
  const isHovering = useHoverDirty(rootRef);
  return (
    <div className={classNames('relative', className)} ref={rootRef}>
      <Button onClick={() => onClick()}>
        <Icon className="mr-5" src={itemMap.size ? ImgUploading : ImgUpload} />
        <span>上传素材</span>
      </Button>
      <div
        style={{ zIndex: 4999 }}
        className={classNames('absolute top-30 right-0 pt-10', {
          hidden: !isHovering,
        })}
      >
        <div className="h-150 w-280 rounded border bg-white">
          {itemMap.size ? (
            <Scrollbars>
              {[...itemMap.values()].map((x) => (
                <div key={x.id} className="flex h-30 items-center px-10">
                  <div className="mr-20 truncate text-black">{x.name}</div>
                  <div className="ml-auto flex-shrink-0 text-black-gray">
                    {x.progress}
                  </div>
                </div>
              ))}
            </Scrollbars>
          ) : (
            <div className="flex h-30 items-center px-10">
              <div className="mr-20 truncate text-black">- - -</div>
              <div className="ml-auto flex-shrink-0 text-black-gray">
                请先上传素材
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default UploadButton;
